<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/tickets/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>پاسخ به تیکت</v-card-title>
      <v-card-text>
        <!--        OTHER FIELDS-->
        <v-row>
          <v-col cols="3">
            <v-text-field color="black" v-model="ticket.title" label="عنوان"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-checkbox
                label="پاسخ فایل ضمیمه دارد؟"
                v-model="has_attachment"
                color="black"
            >
            </v-checkbox>
          </v-col>
          <v-col v-if="has_attachment" cols="2">
            <v-select
                label="نوع فایل پاسخ را مشخص کنید"
                :items="attachment_types"
                v-model="ticket.attachment_type"
                item-value="value"
                item-text="text"
                color="black"
            >
            </v-select>
          </v-col>
          <v-col cols="4" v-if="has_attachment">
            <v-text-field label="فایل"
                          @click="fileDialog = true" prepend-icon="mdi-plus"
                          color="black"
                          v-model="ticket.url"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea color="black" v-model="ticket.content" label="محتوای پیام"></v-textarea>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="reply()">پاسخ</v-btn>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="warning" class="normal-font-btn" @click="clear()">پاک کردن</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="fileDialog" max-width="50vw">
      <drag-and-drop module="notification" ref="file-uploader" @closeUploadFileDialog="fileDialog = false"
                     @changeFile="ticket.url = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";

export default {
  name: "TicketReply",
  components: {DragAndDrop},
  data() {
    return {
      fileDialog: false,
      attachment_types: [
        {value: 'audio', text: 'فایل صوتی'},
        {value: 'video', text: 'ویدیو'},
        {value: 'pdf', text: 'پی دی اف'},
        {value: 'image', text: 'تصویر'},
        {value: 'zip', text: 'فایل فشرده'},
      ],
      has_attachment: false,
      ticket: {
        section: null,
        student_id: null,
        instructor_id: null,
        admin_id: null,
        ticket_id: null,
        url: null,
        sent_by: 'admin',
        attachment_type: null,
        title: null,
        content: null,
        seen: null,
        seen_at: null,
        has_reply: null,
      }
    }
  },
  mounted() {
    this.ticket.ticket_id = this.$route.params.id
  },
  methods: {
    reply() {
      window.axios.post('ticket/crud/reply', this.ticket).then(() => {
        this.openSnackbar("تیکت  با موفقیت پاسخ داده شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    clear() {
      this.ticket = {
        section: null,
        student_id: null,
        instructor_id: null,
        admin_id: null,
        ticket_id: null,
        url: null,
        sent_by: null,
        attachment_type: null,
        title: null,
        content: null,
        seen: null,
        seen_at: null,
        has_reply: null,
      }
    },
  }
}
</script>

<style>
.back-link-icon {
  color: #413e3e !important;
}

.back-link-icon:hover {
  color: orangered !important;
}

.normal-font-btn {
  letter-spacing: normal !important;
}
</style>